var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabbarBookmarks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 26,
    viewBox: "0 0 17 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5421 24.3586C2.53803 25.338 2.13702 25.6683 1.50374 25.6683C0.573042 25.6683 0 25.0408 0 23.9897V3.551C0 1.22741 1.2082 0 3.51257 0H12.8285C15.1308 0 16.3411 1.22741 16.3411 3.551V23.9897C16.3411 25.0408 15.768 25.6683 14.8373 25.6683C14.2019 25.6683 13.8073 25.3401 12.8011 24.3607L8.27179 19.8827C8.22491 19.8262 8.12577 19.8262 8.06929 19.8827L3.5421 24.3586Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabbarBookmarks);
export default __webpack_public_path__ + "static/media/tabbar_bookmarks.adf610258be39e3e6cda9a55de0a485d.svg";
export { ForwardRef as ReactComponent };